import React, { Component } from "react"
import { connect } from 'react-redux'

import { deleteFileAction, getFileAction } from '../../redux/actions/UploadAction'
import { msg } from '../../components/Notifications/MsgBox'
import { MessageText } from "../../configs"
import utilityHelper from '../../helpers/helperUtil'

class UploadList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props
        };
    }

    onDeleteConfirm(event, item, index) {

        event.preventDefault()

        const { deleteFile } = this.props
        const updateBy = ''

        msg.showConfirm(
            "Confirm",
            "ต้องการลบรายการนี้หรือไม่",
            () => {
                msg.hideConfirm()
                //this.props.removeMR_Vendor('remove',index);
                deleteFile(item.transaction_no, item.running, updateBy)
                    .then(response => {
                        this.props.getFile(item.transaction_no)
                    })
                msg.success(MessageText.PAGE.MR.POPUP_MSG_SUCCESS_DELETE_UPLOAD)
            },
            () => {
                msg.hideConfirm()
                console.log("ยกเลิกการลบรายการ")
            },
            () => {
                console.log("ยกเลิกการลบรายการ")
            }
        )
    }

    render() {
        const {
            viewMode,
            mviewMode,
            upload_files,
            file_category
        } = this.props
        const files = upload_files && upload_files.filter(file => file.file_category === file_category)

        return (<table className="sp-table table rrs-table-2">
            <thead>
                <tr className="sp-table-header">
                    <th className="th-table"><div className="th-text">No.</div></th>
                    <th className="th-table"><div className="th-text">ชื่อเอกสารแนบ</div></th>
                    <th className="th-table"><div className="th-text">คำอธิบายเอกสาร</div></th>
                    {
                        viewMode === false && (<th className="th-table"><div className="th-text text-center">ลบ</div></th>)
                    }
                    <th className="th-table"><div className="th-text text-center">แสดง</div></th>
                </tr>
            </thead>
            <tbody>

                {

                    files.length === 0 && (
                        <tr>
                            <td colSpan="5"> <p>ไม่มีรายการ</p> </td>
                        </tr>
                    )
                }

                {
                    files && files.length > 0 && files.map((item, index) => (
                        <tr key={`upload-file-${index}-${file_category}-${utilityHelper.genDateKey()}`}
                        >
                            <td>{index + 1}</td>
                            <td>{item.file_description}</td>
                            <td>{item.file_name_original}</td>
                            {
                                viewMode || mviewMode === false && (
                                    <td className="text-center">
                                        <a href="#main" onClick={(event) => this.onDeleteConfirm(event, item, index)}><i className="icon btn-minus" /></a>
                                    </td>)
                            }
                            <td className="text-center">
                                <a href={item.file_url} target="_blank"><i className="icon icon-preview-eye-blue" /></a>

                            </td>
                        </tr>
                    ))

                }
            </tbody>
        </table>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux } = state
    return {
        transaction_no: MainRedux.transaction_no,
        upload_files: UploadRedux.upload_files,
        mviewMode: MainRedux.viewMode,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteFile: (transactionNo, fileNo, updateBy) => dispatch(deleteFileAction(transactionNo, fileNo, updateBy)),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadList)